module.exports = __webpack_public_path__ + "img/gjng2921_1.43d8594d.svg";